import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import {
    Box,
    List,
    Badge,
    Divider,
    Popover,
    Typography,
    IconButton,
    ListItemText,
    ListSubheader,
    ListItemAvatar,
    ListItemButton,
    Stack,
} from '@mui/material';
// utils
import Iconify from '../../../components/iconify';
import Scrollbar from '../../../components/scrollbar';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import ButtonAction from 'src/components/Button.js/SaveButton';
import CategoryProduct from 'src/components/modal/CatagoryProduct';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { isNumber } from 'lodash';
// ----------------------------------------------------------------------

NotificationItem.propTypes = {
    notification: PropTypes.shape({
        createdAt: PropTypes.instanceOf(Date),
        id: PropTypes.string,
        isUnRead: PropTypes.bool,
        title: PropTypes.string,
        description: PropTypes.string,
        type: PropTypes.string,
        avatar: PropTypes.any,
    }),
};
// ----------------------------------------------------------------------

export default function Category() {
    const [arrCategory, setCategory] = useState([]);
    const [dataPrduct, setDataProduct] = useState({});
    const [arrRendered, setRendered] = useState([]);
    const [tableData, setTableData] = useState([]);

    const [totalInCart, setTotalInCart] = useState(0);

    const navigate = useNavigate();
    const ref = useRef();

    const [getFlags, setGetFlags] = useState(false);
    const [visible, setVisible] = useState(false);

    const [open, setOpen] = useState(null);

    useEffect(() => {
        const data = sessionStorage.getItem('category');
        if (data) {
            try {
                setCategory(JSON.parse(data));
            } catch (error) {}
        }
    }, [arrRendered]);

    useEffect(() => {
        setTotalInCart(arrCategory.length + tableData.length);
    }, [arrCategory, tableData]);

    useEffect(() => {
        glb_sv.commonEvent.subscribe((msg) => {
            if (msg.type === eventList.ADD_PRODUCT && msg.data === 'add') {
                setTotalInCart((prev) => prev + 1);
            } else if (msg.type === eventList.ADD_PRODUCT && isNumber(msg.data)) {
                const data = sessionStorage.getItem('category');
                setTotalInCart(msg.data + (JSON.parse(data)?.length || 0));
            }
        });
    }, []);

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    const getData = useCallback(() => {
        if (getFlags) {
            return;
        }
        const InVal = [];
        sendRequest(serviceList.getListRegisterDeviceOnline, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            // if (message.proc_data.rows[0].o_1.length > 0) setOpen(ref.current);
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        // toast.error(t('error.time_out'));
    };

    const handleClose = () => {
        setOpen(null);
    };

    const handleOpenGetDeviceModal = (data) => {
        setVisible(true);
        setDataProduct(data);
    };

    return (
        <>
            <IconButton
                color={open ? 'primary' : 'default'}
                onClick={() => navigate('/home/category/100')}
                ref={ref}
                sx={{ width: 40, height: 40 }}
            >
                <Badge badgeContent={totalInCart} color="error">
                    <Iconify icon="material-symbols:shopping-cart" width={27} height={27} />
                </Badge>
            </IconButton>
            <CategoryProduct
                setRendered={setRendered}
                arrCategory={arrCategory}
                product={dataPrduct}
                visible={visible}
                setVisible={setVisible}
                dataUpdate={dataPrduct}
            />
            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        mt: 1.5,
                        ml: 0.75,
                        width: 460,
                    },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle1">{t('gio_hang')}</Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {t('your_is')} {arrCategory.length + tableData.length} {t('product_in_category')}
                        </Typography>
                    </Box>
                    <ButtonAction
                        // size="large"
                        onClick={() => {
                            setOpen(null);
                            navigate('/home/category/100');
                        }}
                        type="get"
                        title={t('go_to_category')}
                        // onClick={functOnClick}
                    />
                </Box>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Scrollbar sx={{ height: { xs: 440, sm: 'auto' } }}>
                    {/* ======================online =====================*/}
                    <Divider sx={{ borderStyle: 'dashed' }} />
                    <List
                        disablePadding
                        subheader={
                            tableData.find((item) => item?.status_action === '1') && (
                                <ListSubheader
                                    disableSticky
                                    sx={{
                                        py: 1,
                                        px: 2.5,
                                        typography: 'overline',
                                        color: 'primary.dark',
                                        fontSize: '14px',
                                    }}
                                >
                                    {' '}
                                    {t('lay_tb')} online
                                </ListSubheader>
                            )
                        }
                    >
                        {tableData.length > 0 &&
                            tableData.map((product) => {
                                if (product.status_action === '1') {
                                    return (
                                        <NotificationItem
                                            key={product.device_id}
                                            visible={visible}
                                            online={
                                                glb_sv.client_tp === '04' || glb_sv.client_tp === '05' ? false : true
                                            }
                                            setVisible={setVisible}
                                            handleOpenGetDeviceModal={handleOpenGetDeviceModal}
                                            product={product}
                                        />
                                    );
                                }
                            })}
                    </List>
                    <Divider sx={{ borderStyle: 'dashed' }} />
                    <List
                        disablePadding
                        subheader={
                            tableData.find((item) => item?.status_action === '0') && (
                                <ListSubheader
                                    disableSticky
                                    sx={{
                                        py: 1,
                                        px: 2.5,
                                        typography: 'overline',
                                        color: 'primary.dark',
                                        fontSize: '14px',
                                    }}
                                >
                                    {t('muon_tb')} online
                                </ListSubheader>
                            )
                        }
                    >
                        {tableData.length > 0 &&
                            tableData.map((product) => {
                                if (product.status_action === '0') {
                                    return (
                                        <NotificationItem
                                            key={product.device_id}
                                            online={
                                                glb_sv.client_tp === '04' || glb_sv.client_tp === '05' ? false : true
                                            }
                                            visible={visible}
                                            setVisible={setVisible}
                                            handleOpenGetDeviceModal={handleOpenGetDeviceModal}
                                            product={product}
                                        />
                                    );
                                }
                            })}
                    </List>

                    {/* ======================offline =====================*/}
                    <List
                        disablePadding
                        subheader={
                            arrCategory.find((item) => item.status_action === '1') && (
                                <ListSubheader
                                    disableSticky
                                    sx={{
                                        py: 1,
                                        px: 2.5,
                                        typography: 'overline',
                                        color: 'primary.dark',
                                        fontSize: '14px',
                                    }}
                                >
                                    {t('lay_tb')} offline
                                </ListSubheader>
                            )
                        }
                    >
                        {arrCategory.map((product) => {
                            if (product.status_action === '1') {
                                return (
                                    <NotificationItem
                                        key={product.device_id}
                                        visible={visible}
                                        online={glb_sv.client_tp === '04' || glb_sv.client_tp === '05' ? false : true}
                                        setVisible={setVisible}
                                        handleOpenGetDeviceModal={handleOpenGetDeviceModal}
                                        product={product}
                                    />
                                );
                            }
                        })}
                    </List>

                    <Divider sx={{ borderStyle: 'dashed' }} />
                    <List
                        disablePadding
                        subheader={
                            arrCategory.find((item) => item.status_action === '0') && (
                                <ListSubheader
                                    disableSticky
                                    sx={{
                                        py: 1,
                                        px: 2.5,
                                        typography: 'overline',
                                        color: 'primary.dark',
                                        fontSize: '14px',
                                    }}
                                >
                                    {' '}
                                    {t('muon_tb')} offline
                                </ListSubheader>
                            )
                        }
                    >
                        {arrCategory.map((product) => {
                            if (product.status_action === '0') {
                                return (
                                    <NotificationItem
                                        key={product.device_id}
                                        visible={visible}
                                        online={glb_sv.client_tp === '04' || glb_sv.client_tp === '05' ? false : true}
                                        setVisible={setVisible}
                                        handleOpenGetDeviceModal={handleOpenGetDeviceModal}
                                        product={product}
                                    />
                                );
                            }
                        })}
                    </List>
                </Scrollbar>

                <Divider sx={{ borderStyle: 'dashed' }} />

                {/* <Box sx={{ p: 1 }}>
                    <Button fullWidth disableRipple>
                        View All
                    </Button>
                </Box> */}
            </Popover>
        </>
    );
}

function NotificationItem({ product }) {
    const { avatar, title } = renderContent(product);
    const { t } = useTranslation();
    return (
        <ListItemButton
            // onClick={() => handleOpenGetDeviceModal(product)}
            sx={{
                py: 1.5,
                px: 2.5,
                mt: '1px',
                ...(product.isUnRead && {
                    bgcolor: 'action.selected',
                }),
            }}
        >
            <ListItemAvatar sx={{ paddingRight: '5px' }}>
                <img
                    style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '5px',
                        backgroundColor: (theme) => theme.palette['primary'].lighter,
                    }}
                    src={`${glb_sv.urlGetProductImage(product?.pic_device)}`}
                    alt=""
                />
                {/* <Avatar sx={{ bgcolor: 'background.neutral' }}>{avatar}</Avatar> */}
            </ListItemAvatar>
            <ListItemText
                primary={title}
                secondary={
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        flexWrap={'wrap'}
                        paddingLeft={0.5}
                    >
                        <Typography
                            variant="subtitle2"
                            sx={{
                                maxWidth: '60%',
                                mt: 0.5,
                                display: 'flex',
                                alignItems: 'center',
                                color: 'text.disabled',
                            }}
                        >
                            {t('cabinet')} : {product.cabinet_nm}
                        </Typography>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                maxWidth: '60%',
                                mt: 0.5,
                                display: 'flex',
                                alignItems: 'center',
                                color: 'text.disabled',
                            }}
                        >
                            {t('drawer')} :{' '}
                            {`${product.drawer_nm}  [ ${product?.cell_lc?.row} : ${product?.cell_lc?.column} ]`}
                        </Typography>
                    </Stack>
                }
            />
        </ListItemButton>
    );
}

// ----------------------------------------------------------------------

function renderContent(notification) {
    const title = (
        <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'} paddingLeft={0.5}>
            <Typography
                variant="subtitle2"
                sx={{
                    overflow: 'hidden',
                }}
            >
                {notification.device_nm}
                <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
                    {/* &nbsp; {noCase(notification.description)} */}
                </Typography>
            </Typography>
            <Typography component="span" variant="body1">
                {/* {notification.cabinet_nm} */}x{notification.qty}
            </Typography>
        </Stack>
    );
    return {
        avatar: notification.avatar ? <img alt={notification.title} src={notification.avatar} /> : null,
        title,
    };
}
